import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 62,
  label: "发明人年度发明量分析",
  chart: charts.lineAndBar2D,
  definition: {
    rowDims: [
      {
        name: "inventorNewName",
        label: "发明人",
        table: "patent_inventor",
        limit: 10,
        needTotal: true,
      },
    ],
    colDims: [{ name: "appDate", label: "发明年", dateUnit: "YEAR", limit: 10, needTotal: true }],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
    showNoDataDims: true,
  },
  chartOption: {
    chartType: ChartType.LINE,
    title: "发明人年度发明量分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: true,
    hideLegend: false,
    hideToolbox: false,
  },
};
